import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { catalogueApi } from '../services/api';
import { CatalogueShell, Spinner } from '../components/catalogue/CatalogueShell';
import { FamilyTiles } from '../components/catalogue/CategoryTiles';

export default function FamiliesPage() {
  const { brandId } = useParams();
  const [families, setFamilies] = useState(null);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    catalogueApi.families(brandId).then((r) => setFamilies(r.data));
  }, [brandId]);

  const shown = useMemo(
    () => (families || []).filter((f) => f.name.toLowerCase().includes(filter.toLowerCase())),
    [families, filter]
  );

  return (
    <CatalogueShell brandId={brandId} crumbs={[{ label: 'Families' }]} title="Families" testId="families-page"
      intro="Many designs come as a family: the same idea as a pendant, table lamp, wall light or chandelier.">
      <input
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Filter families..."
        className="text-sm border border-gray-200 rounded-md px-3 py-2 w-full sm:w-64 mb-10 focus:outline-none focus:ring-1 focus:ring-gray-400"
        data-testid="families-filter-input"
      />
      {families ? <FamilyTiles brandId={brandId} families={shown} /> : <Spinner />}
    </CatalogueShell>
  );
}
